import { render } from "./ReviewCard.vue?vue&type=template&id=08c1b68c&ts=true"
import script from "./ReviewCard.vue?vue&type=script&lang=ts"
export * from "./ReviewCard.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__